<template>
  <tr>
    <td>#{{ grupoComissao.id }}</td>
    <td>
      <strong>{{ grupoComissao.nome }}</strong> <br />
    </td>
    <td >{{ grupoComissao.datahora_criacao }}</td>
    <td >{{ grupoComissao.datahora_atualizacao }}</td>
    <td :inner-html.prop="grupoComissao.ativo | booleanHtml" />
    <td class="actions">
      <button
        v-if="!!openEdit"
        type="button"
        class="button button-primary"
        v-on:click="openEdit(grupoComissao)"
      >
        <fa-icon icon="pencil-alt" />
      </button>
      &nbsp;
      <button
        v-if="!!deleteConfirm"
        type="button"
        name="button"
        v-on:click="deleteConfirm(grupoComissao)"
        class="button button-error"
      >
        <fa-icon icon="trash-alt" />
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  name: "RowGrupoComissao",
  props: [
    "grupoComissao",
    "openEdit",
    "deleteConfirm",
    "addGrupoComissao",
    "removeGrupoComissao",
  ],
};
</script>
